import { createSelector } from 'reselect';

const selectStockTransfers = (state: any) => state.stockTransfers;


export const selectStockTransfersCurrentItem = createSelector([selectStockTransfers], (stockTransfers) => stockTransfers.current);

export const selectStockTransfersListItems = createSelector([selectStockTransfers], (stockTransfers) => stockTransfers.list);

export const selectStockTransfersItemById = (itemId: any) =>
    createSelector(selectStockTransfersListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectStockTransfersQueryItems = createSelector([selectStockTransfers], (stockTransfers) => stockTransfers.query);

export const selectStockTransfersCreatedItem = createSelector([selectStockTransfers], (stockTransfers) => stockTransfers.create);

export const selectStockTransfersUpdatedItem = createSelector([selectStockTransfers], (stockTransfers) => stockTransfers.update);

export const selectStockTransfersReadItem = createSelector([selectStockTransfers], (stockTransfers) => stockTransfers.read);

export const selectStockTransfersDeletedItem = createSelector([selectStockTransfers], (stockTransfers) => stockTransfers.delete);

export const selectStockTransfersSearchedItems = createSelector([selectStockTransfers], (stockTransfers) => stockTransfers.search);

export const selectStockTransfersItemsCount = createSelector([selectStockTransfers], (stockTransfers) => stockTransfers.count);

export const selectStockTransfersItemsFilter = createSelector([selectStockTransfers], (stockTransfers) => stockTransfers.filter);